import { Mobile } from "@govlaunch/core";
import * as queryString from "query-string";
import React from "react";

export default function Airtable({ attributes, element, children }) {
  const { embedUrl, embedWidth, embedHeight } = element;

  const parsed = queryString.parseUrl(embedUrl);

  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div contentEditable={false}>
        <Mobile>
          {(isMobile) => {
            const embedQuery = queryString.stringify({
              ...parsed.query,
              layout: isMobile ? "card" : undefined,
            });

            return (
              <div
                css={{
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  overflow: "hidden",
                  marginTop: 10,
                }}
              >
                <iframe
                  src={`${parsed.url}?${embedQuery}`}
                  frameBorder="0"
                  css={{
                    width: "100%",
                  }}
                  style={{
                    embedWidth,
                    embedHeight,
                  }}
                />
              </div>
            );
          }}
        </Mobile>
      </div>
    </div>
  );
}
